import SecretFieldControl from 'components/controls/SecretField';
import TextField from 'components/formik/TextField';
import PropTypes from 'prop-types';
import React from 'react';

const SecretField = props => (
  <SecretFieldControl
    name={props.field.name}
    value={props.field.value}
    {...props}
    input={TextField}
  />
);

SecretField.propTypes = {
  field: PropTypes.object.isRequired,
};

export default SecretField;
